module.exports = __webpack_public_path__ + "img/tips3list2img19120303.7157e958.jpg";